import { render } from "./taxCityLife.vue?vue&type=template&id=80251472&scoped=true"
import script from "./taxCityLife.vue?vue&type=script&lang=js"
export * from "./taxCityLife.vue?vue&type=script&lang=js"

import "./taxCityLife.vue?vue&type=style&index=0&id=80251472&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80251472"]])

export default __exports__